import React, { useMemo, useCallback } from 'react';
import RegistrosTableSection from './RegistrosTableSection';
import RecepcionIndicadoresSection from './RecepcionIndicadoresSection';
import { useRegistrosPeriodo } from '../../hooks/useRegistrosPeriodo';
import { fetchReceptions, exportReceptions } from '@/pages/reception/services/reception.services';
import { receptionColumns, columnsExcel, receptionDataMapper } from '@/pages/reception/utils/receptionColumns';

// Reporte "Recepción de ropa sucia": todos los lotes registrados en el periodo, con las
// mismas columnas y el mismo Excel que la pantalla de recepción (sin las acciones), más
// indicadores y gráficas debajo.
const RecepcionRopaSuciaContent = ({ idLavanderia, dateRange, startDate, endDate }) => {
  const filters = useMemo(
    () => ({ idLavanderia, createdAt: dateRange }),
    [idLavanderia, dateRange],
  );
  const resetKey = JSON.stringify(filters);

  const columns = useMemo(
    () => receptionColumns().filter((c) => c.id !== 'opciones'),
    [],
  );

  const fetchPage = useCallback(
    async ({ page, limit }) => {
      const resp = await fetchReceptions({ limit, page, query: { ...filters } });
      return { data: resp?.data || [], totalRecords: resp?.totalRecords || 0 };
    },
    [filters],
  );

  const fetchAll = useCallback(async () => {
    const resp = await fetchReceptions({ limit: 10000, page: 1, query: { ...filters } });
    return resp?.data || [];
  }, [filters]);

  const registros = useRegistrosPeriodo({ fetchAll, resetKey });

  // El endpoint /reception/export lee `body.query.query`, por eso se envuelve en { query }
  const exportService = useCallback(() => exportReceptions({ query: { ...filters } }), [filters]);

  return (
    <div className="space-y-4">
      <RegistrosTableSection
        title="Recepción de ropa sucia"
        columns={columns}
        fetchPage={fetchPage}
        resetKey={resetKey}
        exportService={exportService}
        exportColumns={columnsExcel}
        exportDataMapper={receptionDataMapper}
        exportFileName={`Recepciones_Ropa_Sucia_${String(startDate).slice(0, 10)}_a_${String(endDate).slice(0, 10)}`}
      />
      <RecepcionIndicadoresSection registros={registros} />
    </div>
  );
};

export default RecepcionRopaSuciaContent;
